export {
  resolveFromCatalog,
  type CatalogResolution,
  type CatalogResolutionFound,
  type CatalogResolutionMisconfiguration,
  type CatalogResolutionUnused as CatalogResolutionNotUsed,
  type CatalogResolutionResult,
  type CatalogResolver,
} from './resolveFromCatalog.ts';
export {
  type CatalogResultMatcher,
  matchCatalogResolveResult,
} from './matchCatalogResolveResult.ts';
